
/* injects from baggage-loader */

const hljs = require('./highlight')

hljs.registerLanguage('xml', require('./languages/xml'))
hljs.registerLanguage('javascript', require('./languages/javascript'))

module.exports = hljs



// WEBPACK FOOTER //
// ./client/components/Wizard/highlight/index.js